// extracted by mini-css-extract-plugin
module.exports = {"head":"ClientAllowancesTable__head--1WDo_","filter":"ClientAllowancesTable__filter--1myAy"};